import { render, staticRenderFns } from "./Revistas.vue?vue&type=template&id=28d51784&"
import script from "./Revistas.vue?vue&type=script&lang=js&"
export * from "./Revistas.vue?vue&type=script&lang=js&"
import style0 from "./Revistas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports